import TeamSlider from './modules/team-slider';
import Ticker from './modules/ticker';
import PostcardsSlider from './modules/postcards-slider';
import initTeamGrid from './modules/team-grid';
import accordionAutomaticInit from './modules/accordion';
import TabsAutomatic from './modules/accessibilityTabs';
import initFlipManager from './modules/flipManager';
import postFilters from "./modules/postFilters"
import timeline from './modules/timeline';
import modalForm from './modules/modal-form';
import initTelephoneDecorator from './modules/telephone-decorator';
import initClickTracking from './modules/click-tracking';
import TextMediaSlider from './modules/text-media-slider';
import FeaturedPostSlider from './modules/featured-post-slider';
import FiftyFiftySlider from './modules/fifty-fifty-slider';
import sitewideBanner from './modules/sitewide-banner';

import {
    watchScroll,
    hasLightNext,
    mobileNavToggle,
    monitorSectionsInViewport,
    setCookie,
    initMainNavDropdowns,
    initMobileNavDropdowns
} from './modules/helpers';

initTelephoneDecorator();
initClickTracking();
sitewideBanner();

jQuery(document).ready(function ($) {
    // Remove no-js class and replace with js.
    $('html').addClass('js').removeClass('no-js');
    window.setCookie = setCookie;

    watchScroll();

    accordionAutomaticInit();
    TabsAutomatic();
    TeamSlider().init();
    Ticker().init();
    PostcardsSlider().init();
    FeaturedPostSlider().init();
    modalForm().init();

    initTeamGrid();
    initFlipManager();
    timeline();
    FiftyFiftySlider().init();
    TextMediaSlider().init();
    //adhoc JS
    hasLightNext();
    mobileNavToggle();
    monitorSectionsInViewport();
    initMainNavDropdowns();
    initMobileNavDropdowns();

    postFilters($);
});
